const MODULE_NAME = "VIDEO_CONSULTATION_SESSION";
const PREPARE_VIDEO_CONSULTATION_SESSION = MODULE_NAME + 'PREPARE_VIDEO_CONSULTATION_SESSION';
const START_VIDEO_CONSULTATION_SESSION = MODULE_NAME + 'START_VIDEO_CONSULTATION_SESSION';
const CLOSE_VIDEO_CONSULTATION_SESSION = MODULE_NAME + 'CLOSE_VIDEO_CONSULTATION_SESSION';

export {
  PREPARE_VIDEO_CONSULTATION_SESSION,
  START_VIDEO_CONSULTATION_SESSION,
  CLOSE_VIDEO_CONSULTATION_SESSION
};
